const config: IConfig = {
  serve: '//rap2-server.ahmq.net',
  keys: ['3ea3fb8c8e1d'],
  session: {
    key: 'koa:sess',
  },
}

export default config
